import React from "react";

// import './Logos.css';

const DarknessLogo = ({ onClickToggle }) => {
	return (
		<div
			style={{ padding: ".6rem", width: "max-content", cursor: "pointer" }}
			className="logo-wrapper dark"
			onClick={onClickToggle}
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				className="dark icon icon-tabler icon-tabler-moon"
				width="30"
				height="30"
				viewBox="0 0 24 24"
				strokeWidth="1.5"
				stroke="currentColor"
				fill="none"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path stroke="none" d="M0 0h24v24H0z" />
				<path d="M16.2 4a9.03 9.03 0 1 0 3.9 12a6.5 6.5 0 1 1 -3.9 -12" />
			</svg>
		</div>
	);
};

export default DarknessLogo;
